module.exports = __webpack_public_path__ + "static/dc-nordeste-1-8060b684213a9d2b5c4fae1abdfbedc6.jpg";